module.exports = __webpack_public_path__ + "img/D201910_1.7f5e106f.jpg";